<template>
  <div>
    <!-- 添加加载中组件 -->
    <div v-if="pageLoading" class="loading-container">
      <div class="loading-spinner">
        <i class="el-icon-loading"></i>
        <p>页面加载中...</p>
      </div>
    </div>

    <!-- 原有的登录页面内容 -->
    <transition v-else name="fade" appear>
      <div class="login-page">
        <div class="card-container">
          <transition name="flip">
            <!-- 登录表单 -->
            <div class="login-container" v-show="!showRegister">
              <div class="login-header">
                <h2 class="login-title">日志管理系统</h2>
                <p class="login-subtitle">欢迎回来，请登录您的账号</p>
              </div>
              
              <el-form ref="loginForm" :model="loginForm" :rules="rules" class="login-form" @submit.native.prevent="handleLogin">
                <el-form-item prop="phone">
                  <el-input 
                    v-model="loginForm.phone"
                    prefix-icon="el-icon-mobile-phone"
                    placeholder="请输入手机号"
                    maxlength="11">
                  </el-input>
                </el-form-item>
                
                <el-form-item prop="password">
                  <el-input 
                    v-model="loginForm.password"
                    prefix-icon="el-icon-lock"
                    type="password"
                    placeholder="请输入密码"
                    show-password
                    @keyup.enter.native="handleLogin">
                  </el-input>
                </el-form-item>

                <el-button 
                  type="primary" 
                  class="login-button"
                  :disabled="isLoginBlocked || loading"
                  @click="handleLogin"
                  native-type="submit">
                  {{ loginButtonText }}
                  <i v-if="loading" class="el-icon-loading loading-icon"></i>
                </el-button>
              </el-form>

              <div class="register-link">
                还没有账号？<a @click.prevent="showRegister = true">立即注册</a>
              </div>
            </div>
          </transition>

          <transition name="flip">
            <!-- 注册表单 -->
            <div class="register-container" v-show="showRegister">
              <div class="login-header">
                <h2 class="login-title">用户注册</h2>
                <p class="login-subtitle">创建您的账号</p>
              </div>

              <el-form ref="registerForm" :model="registerForm" :rules="registerRules" class="login-form">
                <el-form-item prop="username">
                  <el-input 
                    v-model="registerForm.username"
                    prefix-icon="el-icon-user"
                    placeholder="请输入姓名">
                  </el-input>
                </el-form-item>

                <el-form-item prop="department">
                  <el-input 
                    v-model="registerForm.department"
                    prefix-icon="el-icon-office-building"
                    placeholder="请输入部门">
                  </el-input>
                </el-form-item>

                <el-form-item prop="phone">
                  <el-input 
                    v-model="registerForm.phone"
                    prefix-icon="el-icon-mobile-phone"
                    placeholder="请输入手机号"
                    maxlength="11">
                  </el-input>
                </el-form-item>

                <el-form-item prop="password">
                  <el-input 
                    v-model="registerForm.password"
                    prefix-icon="el-icon-lock"
                    type="password"
                    placeholder="请输入密码"
                    show-password>
                  </el-input>
                </el-form-item>

                <el-form-item prop="invite_code">
                  <el-input 
                    v-model="registerForm.invite_code"
                    prefix-icon="el-icon-key"
                    placeholder="请输入邀请码">
                  </el-input>
                </el-form-item>

                <el-button 
                  type="primary" 
                  class="login-button"
                  :disabled="registerLoading"
                  @click="handleRegister">
                  {{ registerLoading ? '注册中' : '注册' }}
                  <i v-if="registerLoading" class="el-icon-loading loading-icon"></i>
                </el-button>
              </el-form>

              <div class="register-link">
                已有账号？<a @click.prevent="showRegister = false">返回登录</a>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { SHA256 } from 'crypto-js'
import request from '@/utils/request'

export default {
  name: 'Login',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    const validateCommon = (rule, value, callback) => {
      if (!value) {
        callback(new Error('此项不能为空'))
      } else if (!/^[\u4e00-\u9fa5a-zA-Z0-9]+$/.test(value)) {
        callback(new Error('只能输入中文、英文和数字'))
      } else {
        callback()
      }
    }
  

    return {
      pageLoading: true,
      showRegister: false,
      loginForm: {
        phone: localStorage.getItem('lastLoginPhone') || '',
        password: ''
      },
      registerForm: {
        username: '',
        department: '',
        phone: '',
        password: '',
        invite_code: ''
      },
      rules: {
        phone: [
          { required: true, trigger: 'blur', validator: validatePhone }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 4, message: '密码长度至少4位', trigger: 'blur' }
        ]
      },
      registerRules: {
        username: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 10, message: '姓名长度不能超过10个字符', trigger: 'blur' },
          { validator: validateCommon, trigger: 'blur' }
        ],
        department: [
          { required: true, message: '请输入部门', trigger: 'blur' },
          { max: 20, message: '部门名称不能超过20个字符', trigger: 'blur' },
          { validator: validateCommon, trigger: 'blur' }
        ],
        phone: [
          { required: true, trigger: 'blur', validator: validatePhone }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 4, message: '密码长度至少4位', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '密码只能包含数字和字母', trigger: 'blur' }
        ],
        invite_code: [
          { required: true, message: '请输入邀请码', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '邀请码只能包含数字和字母', trigger: 'blur' }
        ]
      },
      loading: false,
      registerLoading: false,
      loginFailCount: 0,
      loginBlockedUntil: null,
      remainingSeconds: 0,
      countdownTimer: null
    }
  },

  computed: {
    isLoginBlocked() {
      if (!this.loginBlockedUntil) return false
      return Date.now() < this.loginBlockedUntil
    },
    loginButtonText() {
      if (this.loading) return '登录中...'
      if (this.isLoginBlocked) {
        return `请等待 ${this.remainingSeconds} 秒`
      }
      return '登录'
    }
  },

  watch: {
    'loginForm.phone': {
      handler(newValue) {
        localStorage.setItem('lastLoginPhone', newValue)
      }
    }
  },

  methods: {
    startCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }
      
      this.remainingSeconds = Math.ceil((this.loginBlockedUntil - Date.now()) / 1000)
      
      this.countdownTimer = setInterval(() => {
        this.remainingSeconds--
        if (this.remainingSeconds <= 0) {
          clearInterval(this.countdownTimer)
          this.loginBlockedUntil = null
          this.loginFailCount = 0
        }
      }, 1000)
    },

    async handleLogin() {
      if (this.isLoginBlocked) {
        this.$message.error('登录失败次数过多，请稍后再试')
        return
      }

      this.$refs.loginForm.validate(async (valid) => {
        console.log('valid',valid)
        if (valid) {
          this.loading = true
          try {
            const formData = new FormData()
            formData.append('phone', this.loginForm.phone)
            formData.append('password', SHA256(this.loginForm.password).toString())

            const response = await request.post('/api/login', formData)
            console.log(response.data)
            console.log(response.data.admin)
            if (response.data.success) {
              this.$emit('auth-success')
              this.loginFailCount = 0
              if (response.data.admin) {
                this.$router.push('/admin').catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    throw err
                  }
                })
              } else {
                this.$router.replace('/files').catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    throw err
                  }
                })
              }
            } else {
              this.loginFailCount++
              if (this.loginFailCount >= 5) {
                this.loginBlockedUntil = Date.now() + 60000
                this.startCountdown()
                this.$message.error('登录失败次数过多，请1分钟后再试')
              } else {
                throw new Error(response.data.error || '登录失败')
              }
            }
          } catch (error) {
            this.$message.error(error.message)
          } finally {
            this.loading = false
          }
        }
      })
    },

    async handleRegister() {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          this.registerLoading = true
          try {
            const formData = new FormData()
            formData.append('username', this.registerForm.username)
            formData.append('department', this.registerForm.department)
            formData.append('phone', this.registerForm.phone)
            formData.append('password', this.registerForm.password)
            formData.append('invite_code', this.registerForm.invite_code)

            const response = await request.post('/api/register', formData)

            if (response.data.success) {
              this.$message.success('注册成功')
              this.loginForm.phone = this.registerForm.phone
              this.loginForm.password = this.registerForm.password
              this.$refs.registerForm.resetFields()
              this.showRegister = false
            } else {
              throw new Error(response.data.error || '注册失败')
            }
          } catch (error) {
            this.$message.error(error.message)
          } finally {
            this.registerLoading = false
          }
        }
      })
    }
  },

  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },

  async created() {
    try {
      const response = await request.get('/api/check_auth')
      if (response.data.authenticated) {
        // 用户已登录,根据是否是管理员进行跳转
        if (response.data.admin) {
          // 使用replace而不是push，并添加catch处理重复导航错误
          this.$router.replace('/admin').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
        } else {
          // 使用replace而不是push，并添加catch处理重复导航错误
          this.$router.replace('/files').catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
        }
      }
    } catch (error) {
      console.error('检查登录状态失败:', error)
    } finally {
      // 无论是否登录,都结束加载状态
      setTimeout(() => {
        this.pageLoading = false
      }, 500)
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.5s ease-out;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.card-container {
  width: 90%;
  max-width: 400px;
  position: relative;
  height: 520px;
  padding: 0;
}

.login-container, .register-container {
  width: 100%;
  padding: 30px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  backface-visibility: hidden;
  box-sizing: border-box;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-title {
  font-size: 24px;
  color: #303133;
  margin-bottom: 10px;
  font-weight: 500;
}

.login-subtitle {
  font-size: 14px;
  color: #909399;
}

.login-form {
  margin-top: 20px;
}

.login-button {
  width: 100%;
  margin-top: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.register-link {
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  color: #606266;
}

.register-link a {
  color: #409EFF;
  text-decoration: none;
  cursor: pointer;
}

.register-link a:hover {
  color: #66b1ff;
}

.loading-icon {
  display: inline-block;
  margin-left: 5px;
}

/* 动画相关样式 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.flip-enter-active, .flip-leave-active {
  transition: all 0.6s cubic-bezier(0.4, 0.0, 0.2, 1);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  backface-visibility: hidden;
}

.flip-enter {
  transform: rotateY(180deg);
  opacity: 0;
}

.flip-leave-to {
  transform: rotateY(-180deg);
  opacity: 0;
}

.flip-enter-to, .flip-leave {
  transform: rotateY(0);
  opacity: 1;
}

.fade-enter-active {
  transition: opacity 0.5s ease;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

/* 添加加载动画相关样式 */
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  text-align: center;
}

.loading-spinner i {
  font-size: 50px;
  color: #409EFF;
  margin-bottom: 10px;
}

.loading-spinner p {
  color: #606266;
  font-size: 16px;
  margin: 10px 0 0;
}
</style> 